export default function initSentry () {

}
